import {
  Component,
  input,
  signal,
  inject,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  MatListItemIcon,
  MatListItem,
  MatListItemTitle,
  MatListItemMeta,
} from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterModule, Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { AccessMenuItem } from 'src/app/interfaces/users/access.interface';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  animations: [
    trigger('expandContractMenu', [
      transition(':enter', [
        style({ opacity: 0, height: '0px' }),
        animate('200ms ease-in-out', style({ opacity: 1, height: '*' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in-out', style({ opacity: 0, height: '0px' })),
      ]),
    ]),
  ],
  imports: [
    MatListItemIcon,
    MatListItem,
    MatListItemTitle,
    MatIcon,
    RouterLink,
    RouterModule,
    MatListItemMeta,
    TranslateModule,
  ],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
})
export class MenuItemComponent implements OnChanges {
  private readonly router = inject(Router);

  item = input.required<AccessMenuItem>();
  collapsed = input(false);

  nestedMenuOpen = signal(false);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['collapsed']) {
      if (this.collapsed()) {
        this.nestedMenuOpen.set(false);
      } else {
        this.checkAndOpenSubmenu();
      }
    }
  }

  isRouteActive(route?: string): boolean {
    if (!route) return false;

    return this.router.isActive(route, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  isMainMenuItemActive(): boolean {
    const menu = this.item();

    if (menu.subItems?.length) {
      return menu.subItems.some((sub) =>
        this.isRouteActive(sub.route)
      );
    }

    return this.isRouteActive(menu.route);
  }

  checkAndOpenSubmenu() {
    const subItems = this.item()?.subItems ?? [];

    const isActive = subItems.some((sub) =>
      this.isRouteActive(sub.route)
    );

    this.nestedMenuOpen.set(isActive);
  }

  toggleNested() {
    if (!this.item().subItems) return;

    this.nestedMenuOpen.set(!this.nestedMenuOpen());
  }
}
